import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import SectorSidebar from '../components/SectorSidebar';
import Accreditations from '../components/Accreditations';
import SectorImageSlider from '../components/SectorImageSlider';
import { findSectorById } from '../utils/sectorUtils';
import TitlePage from '../components/TitlePage';
import headerImage from '../assets/images/about/11.jpg';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PageContainer = styled(Box)(({ theme }) => ({
  paddingBottom: '2rem'
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '12px',
  border: '1px solid #E2E8F0',
  padding: '2rem',
  minHeight: '600px'
}));

const SectorTitle = styled(Typography)(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 700,
  color: '#1A365D',
  marginBottom: '2rem'
}));

const SectorContent = styled('div')({
  marginTop: '2rem',
  whiteSpace: 'pre-line',
  color: '#475569',
  fontSize: '1.1rem',
  lineHeight: 1.7,
  '& ul': {
    paddingLeft: '2rem',
    '& li': {
      marginBottom: '0.5rem'
    }
  }
});

const LoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px'
});

const SectorsAirMetrologie = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [activeSector, setActiveSector] = useState(searchParams.get('sector') || 'prestationmecanique');
  const [isLoading, setIsLoading] = useState(false);
  const currentSector = findSectorById('airmetrologie', activeSector);

  useEffect(() => {
    const sectorParam = searchParams.get('sector');
    if (sectorParam) {
      setActiveSector(sectorParam);
    }
  }, [searchParams]);

  const handleSectorChange = (sectorId) => {
    setIsLoading(true);
    setActiveSector(sectorId);
    setSearchParams({ sector: sectorId });
    
    // Défilement vers le titre du secteur
    const titleElement = document.querySelector('.sector-title-anchor');
    if (titleElement) {
      const offset = 150; // Augmentation de l'offset pour voir la carte entière
      const elementPosition = titleElement.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    
    // Simuler un délai de chargement
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  };

  return (
    <PageContainer>
      <Box mb={6}>
        <TitlePage 
          title="Secteurs AIR MÉTROLOGIE" 
          image={headerImage}
        />
      </Box>

      <Container maxWidth="xl">
        <Grid container spacing={4}>
          {/* Sidebar */}
          <Grid item xs={12} md={3}>
            <SectorSidebar
              company="airmetrologie"
              activeSector={activeSector}
              onSectorChange={handleSectorChange}
            />
          </Grid>

          {/* Contenu principal */}
          <Grid item xs={12} md={6}>
            <ContentContainer>
              {isLoading ? (
                <LoadingContainer>
                  <CircularProgress />
                </LoadingContainer>
              ) : currentSector && (
                <>
                  <SectorTitle className="sector-title-anchor">
                    {currentSector.name}
                  </SectorTitle>
                  
                  {/* Slider d'images */}
                  {currentSector?.images && currentSector.images.length > 0 && (
                    <SectorImageSlider 
                      images={currentSector.images} 
                      sector={currentSector.id}
                      company="airmetrologie"
                    />
                  )}

                  <SectorContent>
                    {currentSector.content}
                  </SectorContent>
                </>
              )}
            </ContentContainer>
          </Grid>

          {/* Accréditations */}
          <Grid item xs={12} md={3}>
            <Accreditations 
              company="airmetrologie"
              activeSector={activeSector} 
            />
          </Grid>
        </Grid>
      </Container>
    </PageContainer>
  );
};

export default SectorsAirMetrologie;
